"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = exports.proficiencyLabels = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
exports.proficiencyLabels = {
    'needs-work': {
        singular: 'needs work',
        plural: 'need work',
    },
    'in-progress': {
        singular: 'in progress',
        plural: 'in progress',
    },
    mastered: {
        singular: 'mastered',
        plural: 'mastered',
    },
    'not-started': {
        singular: 'not started',
        plural: 'not started',
    },
};
exports.useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        padding: '4px 12px',
        borderRadius: 14,
        fontFamily: theme.typography.fontFamily,
        fontWeight: 500,
        fontSize: '14px',
        '&$selected': {
            padding: '2px 10px',
            borderWidth: 2,
            borderStyle: 'solid',
        },
        outline: 'none',
    },
    button: {
        border: 'none',
        cursor: 'pointer',
    },
    countOnly: {
        padding: '4px 8px',
    },
    selected: {},
    needsWork: {
        color: 'rgb(90, 15, 17)',
        backgroundColor: '#FFBDBD',
        '&$selected': {
            borderColor: 'rgb(90, 15, 17)',
        },
    },
    inProgress: {
        color: 'rgb(107, 44, 21)',
        backgroundColor: '#FCE588',
        '&$selected': {
            borderColor: 'rgb(107, 44, 21)',
        },
    },
    mastered: {
        color: 'rgb(14, 73, 51)',
        backgroundColor: 'rgb(216, 245, 234)',
        '&$selected': {
            borderColor: 'rgb(14, 73, 51)',
        },
    },
    notStarted: {
        color: 'rgb(38, 50, 56)',
        backgroundColor: 'rgb(236, 239, 241)',
        '&$selected': {
            borderColor: 'rgb(38, 50, 56)',
        },
    },
}); });
var ProficiencyCount = function (_a) {
    var _b;
    var _c = _a.button, button = _c === void 0 ? false : _c, classNameProp = _a.className, count = _a.count, _d = _a.countOnly, countOnly = _d === void 0 ? false : _d, proficiency = _a.proficiency, _e = _a.selected, selected = _e === void 0 ? false : _e, other = __rest(_a, ["button", "className", "count", "countOnly", "proficiency", "selected"]);
    var classes = exports.useStyles();
    var labels = exports.proficiencyLabels[proficiency];
    var Component = button ? 'button' : 'span';
    var label = '';
    if (!countOnly) {
        label = count === 1 ? " " + labels.singular : " " + labels.plural;
    }
    return (react_1.default.createElement(Component, __assign({ className: clsx_1.default(classes.root, (_b = {},
            _b[classes.selected] = selected,
            _b[classes.button] = button,
            _b[classes.countOnly] = countOnly,
            _b[classes.needsWork] = proficiency === 'needs-work',
            _b[classes.inProgress] = proficiency === 'in-progress',
            _b[classes.mastered] = proficiency === 'mastered',
            _b[classes.notStarted] = proficiency === 'not-started',
            _b), classNameProp) }, other),
        count,
        label));
};
exports.default = ProficiencyCount;
//# sourceMappingURL=ProficiencyCount.js.map